var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "dashboard_0" },
    [
      _vm.ticketViewList && _vm.ticketViewList.length > 0
        ? _c(
            "el-row",
            { attrs: { gutter: 4 } },
            _vm._l(_vm.ticketViewList, function(each) {
              return _c(
                "el-col",
                { key: each.id, attrs: { span: 6 } },
                [_c("DashboardTicketTable", { attrs: { view: each } })],
                1
              )
            }),
            1
          )
        : _c("div", [
            _c(
              "div",
              {
                staticStyle: {
                  margin: "1vw",
                  "font-size": "5vw",
                  color: "#efefef"
                }
              },
              [_vm._v("未配置 Dashboard")]
            ),
            _vm._v(" "),
            _c(
              "div",
              {
                staticStyle: {
                  margin: "1vw",
                  "font-size": "2vw",
                  color: "#efefef"
                }
              },
              [_vm._v("可通过 设置 > 视图管理 配置")]
            )
          ])
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-f0e1f956", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-f0e1f956","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/ticket/TicketDashboard.vue
// module id = 756
// module chunks = 75